module.exports = (__webpack_require__(8))(5);


//////////////////
// WEBPACK FOOTER
// delegated ./clients/web/src/events.js from dll-reference girder_lib
// module id = 178
// module chunks = 0